import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CustomAbpHttpInterceptor } from '@shared/common/session/custom-abp-http-interceptor';

import * as BypassedApiServiceProxies from './bypassed-proxies';

@NgModule({
    providers: [
        BypassedApiServiceProxies.BypassedCommissionServiceProxy,
        BypassedApiServiceProxies.BypassedOrderServiceProxy,
        BypassedApiServiceProxies.BypassedCommissionChurnReportServiceProxy,
        { provide: HTTP_INTERCEPTORS, useClass: CustomAbpHttpInterceptor, multi: true },
    ],
})
export class BypassedServiceProxyModule {}
